export default __webpack_public_path__ + "static/media/training-illustration27.3a8a03e0.png";